import React from "react"
import Modal from "react-modal"
import styled from "styled-components"

const ModalContent = styled.div`
  background: #fff;
  padding: 20px 30px;
  top: 20%;
  color: #000000;
  font-size: 12px;
  max-width: 540px;
  margin: auto;
  border: 1px solid transparent;
  border-radius: 4px;

  & .paragraph{
    text-align: justify;
  }
  & .title {
    font-size: 15px;
    font-weight: bold;
    color: #034168;
  }

  & button{
    font-weight: 500;
    font-style: normal;
    -webkit-letter-spacing: 1px;
    -moz-letter-spacing: 1px;
    -ms-letter-spacing: 1px;
    letter-spacing: 1px;
    color: #202122;
    font-size: 20px;
    margin-top: 0;
    background: linear-gradient( 
135deg, #999a9f 0%, #999a9f 21%, #b0b0b3 21%, #b0b0b3 48%, #cbcacb 48%, #cbcacb 100% );
    display: inline-block;
    border: none;
    font-size: 17px;
    padding: 5px 25px;
  }
`

const ModalCondition = ({
  isOpen,
  onAfterOpen,
  onRequestClose,
  ariaHideApp
}) => {
  const modalStyles = {
    content: {
      textAlign: "center",
      height: "100%",
      display: "flex",
      alignItems: "center",
      background: "none",
      border: "none",
      top: "0",
      bottom: "0",
      left: "0",
      right: "0"
    },
    overlay: {
      background:  'rgba(142, 139, 138, 0.42)'
    }
  }

  return (
    <Modal
      isOpen={isOpen}
      onAfterOpen={onAfterOpen}
      onRequestClose={onRequestClose}
      ariaHideApp={ariaHideApp}
      style={modalStyles}
      contentLabel="registerForm"
    >
      <div className="container">
        <ModalContent>
          <p className="title">
            Realice transacciones seguras sin necesidad de memorizar su clave.
          </p>
          <p className="paragraph">
            Ahora gracias a la <strong>CLAVE TEMPORAL</strong> de compras, Usted
            podrá realizar transacciones rápidas y seguras. Recibirá una clave
            diferente para cada transacción a su <strong>CELULAR</strong> o a su{" "}
            <strong>CORREO ELECTRÓNICO</strong> registrado.
          </p>{" "}
          <p className="paragraph">
            Para utilizar este servicio debe actualizar sus datos llamando a
            nuestro <strong>Call Center 1800 DINERS (346377).</strong>
          </p>
          <button onClick={onRequestClose}>Cerrar</button>
        </ModalContent>
      </div>
    </Modal>
  )
}

export default ModalCondition



// WEBPACK FOOTER //
// ./src/components/ModalCondition.js